import { Plus } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/components/ui/button';
import { ReadPostgridAttachment } from '@/services/api/generated/postgridService';

import { AttachmentItem } from './AttachmentItem';

interface AttachmentListProps {
  attachments: ReadPostgridAttachment[];
  onRemove?: (id: string) => void;
  onAdd?: () => void;
  layout?: 'grid' | 'list';
  showAddButton?: boolean;
  className?: string;
  matterId?: string;
}

export const AttachmentList: React.FC<AttachmentListProps> = ({
  attachments,
  onRemove,
  onAdd,
  layout = 'list',
  showAddButton = true,
  className = '',
  matterId,
}) => {
  const hasAttachments = attachments.length > 0;

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Attachments Grid/List */}
      {hasAttachments ? (
        <div
          className={
            layout === 'grid'
              ? 'grid grid-cols-1 md:grid-cols-2 gap-3'
              : 'space-y-2'
          }
        >
          {attachments.map((attachment) => (
            <AttachmentItem
              key={attachment.id}
              attachment={attachment}
              onRemove={onRemove}
              matterId={matterId}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-6 text-slate-500 border border-dashed border-slate-200 rounded-lg">
          <div className="text-sm font-medium">No attachments yet</div>
          <div className="text-xs text-slate-400 mt-1">
            Add files to include with this correspondence
          </div>
        </div>
      )}

      {/* Add Attachment Button */}
      {showAddButton && onAdd && (
        <Button
          variant="outline"
          size="sm"
          onClick={onAdd}
          className="w-full justify-center gap-2 border-dashed border-slate-300 text-slate-600 hover:border-slate-400 hover:text-slate-700"
        >
          <Plus className="h-4 w-4" />
          Add Attachment
        </Button>
      )}
    </div>
  );
};
